import { Card, EmptyState, SecondaryButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { PUBLIC_CHANGELOG_URL } from '@webapp/platform/discover-more/constants'
import { useChangelogReleaseListPresenter } from './useChangelogReleaseListPresenter'
import { ChangelogReleaseList } from '../../views/ChangelogReleaseList'
import messages from '../../views/ChangelogReleaseList/messages'
import { ChangelogReleaseListLoader } from '../../views/ChangelogReleaseListLoader'

export const ChangelogReleaseListPresenter = () => {
  const intl = useProcurifyIntl()

  const {
    data: { releases, placeholderCount },
    states: { isLoading },
    commands: { onReleaseClick },
  } = useChangelogReleaseListPresenter()

  if (isLoading) {
    return <ChangelogReleaseListLoader count={placeholderCount} />
  }

  if (releases.length === 0) {
    return (
      <Card>
        <Card.Content>
          <EmptyState
            context='information'
            header={intl.formatMessage(messages.emptyStateHeader)}
            content={intl.formatMessage(messages.emptyStateDescription)}
            button={
              <a
                href={PUBLIC_CHANGELOG_URL}
                target='_blank'
                rel='noopener noreferrer'
              >
                <SecondaryButton type='button'>
                  {intl.formatMessage(messages.emptyStateAction)}
                </SecondaryButton>
              </a>
            }
          />
        </Card.Content>
      </Card>
    )
  }

  return (
    <ChangelogReleaseList releases={releases} onReleaseClick={onReleaseClick} />
  )
}

ChangelogReleaseListPresenter.displayName = 'ChangelogReleaseListPresenter'
